import * as React from "react";
const SvgChevron = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 10, viewBox: "0 0 10 10", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", fillRule: "evenodd", stroke: "#BCBCBC", strokeWidth: 2, d: "M9.243 1L5 5.243.757 1" }));
export default SvgChevron;
